module.exports = __webpack_public_path__ + "img/1787895843620151297.11f4eedc.png";